import { stringify } from 'qs';
import { loadState } from './localStore';
export const TOKEN_KEY = 'token';
const getToken = () => loadState(TOKEN_KEY) || null;
const serialiseParams = (params) => stringify(params, { skipNulls: true });
export function request(method, domain, directory, params, headers) {
    const serialisedParams = serialiseParams(params);
    const token = getToken();
    // note: ternary ensures `undefined` does not get added to end of url
    const searchParams = serialisedParams ? `?${serialisedParams}` : '';
    return fetch(`${domain}${directory}${searchParams}`, {
        method,
        headers: token && {
            ...headers,
            Authorization: `Bearer ${token}`,
        },
    }).then(res => {
        if (!res.ok) {
            throw Error(res.statusText);
        }
        return res;
    });
}
export function get(domain, directory, params, headers) {
    return request('GET', domain, directory, params, headers).then(res => res.json());
}
export function mutate(method, domain, directory, data) {
    const token = getToken();
    return fetch(`${domain}${directory}`, {
        method,
        headers: token && {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
    }).then(res => {
        if (!res.ok) {
            throw Error(res.statusText);
        }
        return res.json();
    });
}
export function put(domain, directory, data) {
    return mutate('PUT', domain, directory, data);
}
export function patch(domain, directory, data) {
    return mutate('PATCH', domain, directory, data);
}
export function post(domain, directory, data) {
    return mutate('POST', domain, directory, data);
}
//# sourceMappingURL=request.js.map